import { render, staticRenderFns } from "./ReSendQueueStep2.vue?vue&type=template&id=5945ea56&scoped=true&"
import script from "./ReSendQueueStep2.vue?vue&type=script&lang=js&"
export * from "./ReSendQueueStep2.vue?vue&type=script&lang=js&"
import style0 from "./ReSendQueueStep2.vue?vue&type=style&index=0&id=5945ea56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5945ea56",
  null
  
)

export default component.exports